import { useState, useEffect, useRef } from 'react';
import { Container, Button,
  IconButton, Typography, Avatar,
  CardHeader, Divider, TextField } from "@mui/material";
import { Wrapper, MessagesContainer, Card,
  Row, Timer,
  WritingMessageBox, Status } from "./style";
import MicIcon from '@mui/icons-material/Mic';
import SendIcon from '@mui/icons-material/Send';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from '../../../functions/requestInterceptor'
import voiceAxios from '../../../functions/voiceRequestInterceptor'
import { useNavigate, useParams } from 'react-router-dom';
import Header from './header';
import { ticketsStatus } from '../../../functions/ticketsStatus'
import MessageListBox from './messageListBox'
import ChangeStatusAlertModal from './ChangeStatusAlertModal';
import StarIcon from '@mui/icons-material/Star'
import BlockIcon from '@mui/icons-material/Block'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import AttachFile from './attachFile';
import { useTranslation } from 'react-i18next';
import MessageLimitModal from './messageLimitModal'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { toast } from 'react-toastify';

const mimeType = "audio/mp3";
var timeoutStatus = 0;

export default function Chat() {
  const { t } = useTranslation('translation', { keyPrefix: 'chat' });

  const navigate = useNavigate()
  const urlParams = useParams()

  const selfUser = JSON.parse(localStorage.getItem('user'))
  const [audience, setAudience] = useState({})
  const [status, setStatus] = useState('')
  const [reminder, setReminder] = useState('')
  const [category, setCategory] = useState({})
  const [isImportant, setIsImportant] = useState(false)
  const [isBanned, setIsBanned] = useState(false)

  const getData = () => {
    axios.get(`/tickets/${urlParams.ticketId}/`)
     .then((response) => {
       setAudience(response.data.user)
       setStatus(response.data.status)
       setCategory(response.data.category)
       setIsImportant(response.data.user.important)
       setIsBanned(response.data.user.banned)
       setReminder(response.data.reminder)
      //Seen
      if (selfUser?.type === 'admin' && response.data.status === 'OPEN') {
        handleChangeStatus('SEEN')
      }
     })
     .catch((error) => {
       setLoading(false)
       if(error?.response?.status === 401) {
         navigate('/login', {
           state: {
             next: window.location.pathname
           }
         })
       }
     });
  }

  useEffect( () => {
    let interval
    if (selfUser?.type === 'user') {
      interval = setInterval(() => {
        getData()
      }, 10000)
    }

    return () => clearInterval(interval)
  }, [])

  const [permission, setPermission] = useState(false);
  const mediaRecorder = useRef(null);
  const chatContainer = useRef(null);
  const [recordingStatus, setRecordingStatus] = useState("inactive");
  const [stream, setStream] = useState(null);
  const [audio, setAudio] = useState(null)
  const [imageFile, setImageFile] = useState(null)
  const [audioFile, setAudioFile] = useState(null)
  const [message, setMessage] = useState('')
  const [uploadStatus, setUploadStatus] = useState('');
  const [loading, setLoading] = useState(true);

  const handleChangeStatus = (status, changeByAdmin) => {
    axios.patch(`/tickets/${urlParams.ticketId}/status/`, {status: status})
    .then((response) => {
      setStatus(response.data.status)
      if (changeByAdmin) {
        toast.success('وضعیت درخواست با موفقیت تغییر کرد.', {
          position: "top-right"
        });
      }
    })
    .catch((error) => {
      toast.error(error?.response?.data?.detail, {
        position: "top-right"
      });
    });
  }

  const handleChangeCategory = (newCategory) => {
    axios.patch(`/tickets/${urlParams.ticketId}/category/`, {category: newCategory})
    .then((response) => {
      setCategory(response.data.category)
      toast.success('دسته بندی با موفقیت تغییر کرد.', {
        position: "top-right"
      });
    })
    .catch((error) => {
      toast.error(error?.response?.data?.detail, {
        position: "top-right"
      });
    });
  }

  const handleDeleteReminder = () => {
    setReminder('')
  }

  const handleSetReminder = (value) => {
    setReminder(value)
  }

  const scrollToBottom = () => {
    chatContainer.scrollTop = chatContainer.scrollHeight;
  };

  const [messageList, setMessageList] = useState([]);

  const getMessageList = () => {
    axios.get(`/tickets/${urlParams.ticketId}/messages/list/`)
    .then((response) => {
      if (response.data.length > messageList.length) {
        scrollToBottom()
      }
      setMessageList(response.data)
      setLoading(false)
      // setAudio(null)
      setImageFile(null)
    })
    .catch((error) => {
      setLoading(false)
      if(error?.response?.status === 401) {
        navigate('/login', {
          state: {
            next: window.location.pathname
          }
        })
      }
    });
  }

  useEffect( () => {
    getData()
    getMessageList()
    const interval = setInterval(() => {
      getMessageList()
    }, 10000)

    // scrollToBottom()

    return () => clearInterval(interval)
  }, [])

  const [failedAudio, setFailedAudio] = useState(null)
  const sendMessage = (params) => {
    if (status === 'CLOSED') {
      setOpenMessageLimit(true)
      return
    }
    axios.post(`/tickets/${urlParams.ticketId}/messages/`, params)
    .then((response) => {
      setMessage('')
      if (params.type === 'text') {
        setMessageList([...messageList, {
          message: params.message,
          date: new Date(),
          type: 'text',
          sender: {
            ...selfUser
          }
        }])
      } else {
        setAudio(null)
        setFailedAudio(null)
        getMessageList()
      }
    })
    .catch((error) => {
      setFailedAudio(audio)
      console.log(error);
    });
  }

  const handleUploadVoice = (file) => {
    setSendAudio(false)
    setUploadStatus('uploading')

    const data = new FormData();
    data.append('file', file, file.name)

    voiceAxios.post('/upload/', data)
    .then((response) => {
      sendMessage({
        file: response.data.id,
        type: 'voice',
        message: ''
      })
      setUploadStatus('uploaded')
    })
    .catch((error) => {
      console.log(error);
      setUploadStatus('fail')
    });
  }

  // const resendVoice = () => {
  //   handleUploadVoice(audioFile)
  // }

  const stopRecording = () => {
    setRecordingStatus("inactive");
    //stops the recording instance
    mediaRecorder.current.stop();
    mediaRecorder.current.onstop = () => {
      stream.getTracks() // get all tracks from the MediaStream
        .forEach( track => track.stop() ); // stop each of them
      setStream(null)
      setPermission(false)
      window.clearTimeout(timeoutStatus);
    };
  };

  const handleLimition = () => {
    stopRecording()
  }

  const startRecording = async () => {
    setRecordingStatus("recording");

    //create new Media recorder instance using the stream
    const media = new MediaRecorder(stream, { type: mimeType });
    //set the MediaRecorder instance to the mediaRecorder ref
    mediaRecorder.current = media;
    //invokes the start method to start the recording process
    mediaRecorder.current.start();
    mediaRecorder.current.ondataavailable = (event) => {
      if (typeof event.data === "undefined") return;
      if (event.data.size === 0) return;
      
      //creates a blob file from the audiochunks data
      const audioBlob = new Blob([event.data], { type: mimeType });
      const file = new File( [ audioBlob ], "voice.mp3", { type: mimeType} );
      setAudioFile(file)

      // if (selfUser.type === 'admin') {
        // handleUploadVoice(file)
      // } else {
      //   setOpenConfirmationModal(true)
      // }

      //creates a playable URL from the blob file.
       const audioUrl = URL.createObjectURL(audioBlob);
       setAudio(audioUrl);
    };

    timeoutStatus = setTimeout(() => {
      handleLimition()
    }, 180000)
  };

  const [sendAudio, setSendAudio] = useState(false)
  useEffect(() => {

    if (sendAudio) {
      handleUploadVoice(audioFile)
    }
  }, [audioFile])

  const getMicrophonePermission = async () => {
    if ("MediaRecorder" in window) {
        try {
            const streamData = await navigator.mediaDevices.getUserMedia({
                audio: true,
                video: false,
            });
            setStream(streamData);
            setPermission(true);
        } catch (err) {
            alert(err.message);
        }
    } else {
        alert("The MediaRecorder API is not supported in your browser.");
    }
  }

  useEffect(() => {
    if (permission) {
      startRecording()
    }
  }, [permission])

  const [openMessageLimit, setOpenMessageLimit] = useState(false)

  const isAllowedToRecord = () => {
    if (status === 'CLOSED') {
      setOpenMessageLimit(true)
      return false
    }
    
    if (selfUser.type === 'user') {
      if (category.id === 1) return false

      const userMsg = []
      var i = messageList.length - 1
      while (i >= 0 && messageList[i].sender.id === selfUser.id) {
        userMsg.push(messageList[i])
        i--
      }

      const hasVoiceMsg = userMsg.filter(item => item?.file?.mime_type === 'audio/mpeg')

      const countOfVoiceMsg = hasVoiceMsg.length
      if (countOfVoiceMsg) {
        if (category.id === 7) {
          const lastVoiceMsgUTc = new Date(hasVoiceMsg[0].date)
          const nowUTC = new Date().getTime() + (new Date().getTimezoneOffset() * 60 * 1000)
          const diffTime = Math.abs(nowUTC - lastVoiceMsgUTc)

          const diffMinutes = Math.floor(diffTime / (1000 * 60))
          const diffDays = Math.floor(diffMinutes / (60 * 24))
          // for testing
          if ( window.location.host.includes('.ir') && diffMinutes > 10) return true
          // for production
          if ( diffDays > 7) return true
          return false
        }
        return false
      }
      
      if (!hasVoiceMsg.length) {
        if (!messageList.length) {
          return true
        } else return status === 'WAITING_FOR_USER_RESPONSE' || status === 'OPEN'
      }
    } else {
      return true
    }
  }
  const handleMic = () => {
    const isAllowed = isAllowedToRecord()
    if (isAllowed) {
      if (!permission) {
        getMicrophonePermission()
      } else if (recordingStatus === "inactive") {
        startRecording()
      } else {
        stopRecording()
        setSendAudio(true)
      }
    } else {
      setOpenMessageLimit(true)
    }
  }

  const cancelRecording = () => {
    setRecordingStatus("inactive");
    //stops the recording instance
    mediaRecorder.current.stop();
    mediaRecorder.current.onstop = () => {
      stream.getTracks() // get all tracks from the MediaStream
        .forEach( track => track.stop() ); // stop each of them
      setStream(null)
      setPermission(false)
      window.clearTimeout(timeoutStatus);
    };
  }

  // The state for our timer
  const [count, setCount] = useState(0);
  const [time, setTime] = useState("00:00,0");

  var initTime = new Date();

  const showTimer = (ms) => {
    const msecond = Math.floor((ms / 100) % 10)
      .toString()
    const second = Math.floor((ms / 1000) % 60)
      .toString()
      .padStart(2, "0");
    const minute = Math.floor((ms / 1000 / 60) % 60)
      .toString()
      .padStart(2, "0");
    setTime(
      minute + ":" + second + ',' + msecond
    );
  };

  const clearTime = () => {
    setTime("00:00,0");
    setCount(0);
  };

  useEffect(() => {
    var id
    if (recordingStatus !== 'recording') {
      clearTime()
      clearInterval(id);
      return;
    }
    id = setInterval(() => {
      var left = count + (new Date() - initTime);
      setCount(left);
      showTimer(left);
      if (left <= 0) {
        setTime("00:00,0");
        clearInterval(id);
      }
    }, 1);
    return () => clearInterval(id);
  }, [recordingStatus]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      sendMessage({type: 'text', message: message})
    }
  };

  const [statusAlert, setStatusAlert] = useState(false)
  const handleGoingBack = () => {
    if (selfUser?.type === 'admin') {
      if (messageList[messageList.length - 1].sender.id === selfUser.id) {
        if (status === 'CLOSED' || status === 'WAITING_FOR_USER_RESPONSE') {
          navigate('/')
        } else {
          setStatusAlert(true)
        }
      } else {
        navigate('/')
      }
    } else {
      navigate('/')
    }
  }

  const handleImportantUser = (value) => {
    axios.patch(`/users/${audience.id}/important/`, {important: value})
     .then((response) => {
       setIsImportant(value)
     })
     .catch((error) => {
       console.log(error);
     });
  }

  const handleBlockUser = (value) => {
    axios.patch(`/users/${audience.id}/block/`, {banned: value})
     .then((response) => {
       setIsBanned(value)
     })
     .catch((error) => {
       console.log(error);
     });
  }

  const startToUploadingFile = (file) => {
    setImageFile(file)
  }

  const categoryName = selfUser?.type === 'user' ? category?.parent?.name || category.name : category.name

  return (
    <Container maxWidth='xs' dir='rtl' sx={{padding: 0, height: '100%', position: 'relative'}}>
      <Wrapper>
        <Card>
          <CardHeader
            avatar={
              <Avatar
                sx={{ bgcolor: '#de0b0b'}}
                style={{
                  marginRight: 0,
                  marginLeft: 4
                }}
              >
                {audience?.first_name?.charAt(0)}
              </Avatar>
            }
            action={
              <Row>
                <IconButton>
                  <ArrowBackIcon onClick={handleGoingBack} />
                </IconButton>
                <Status status={status}>
                  {ticketsStatus[status]}
                </Status>
                {selfUser?.type === 'admin' && !!isImportant &&
                  <StarIcon
                    onClick={() => handleImportantUser(false)}
                    style={{ color: '#FFD700'}} />
                }
                {selfUser?.type === 'admin' && !isImportant &&
                  <StarBorderIcon
                    onClick={() => handleImportantUser(true)}
                    style={{ color: '#FFD700'}} />
                }
                {selfUser?.type === 'admin' && !!isBanned &&
                  <BlockIcon
                    onClick={() => handleBlockUser(false)}
                    style={{ color: '#cd0000' }}
                  />
                }
                {selfUser?.type === 'admin' && !isBanned &&
                  <RemoveCircleOutlineIcon
                    onClick={() => handleBlockUser(true)}
                  />
                }
                
              </Row>
            }
            title={categoryName}
            subheader={
              <span style={{fontSize: '12px'}}>
                {`${audience.first_name} ${audience.last_name} `}
                {selfUser.type === 'admin' && `(${audience.mobile_number})`}
                {selfUser.type === 'admin' &&
                   <IconButton onClick={() => navigate(`/user/${audience.id}`)}>
                    <FilterAltIcon fontSize='small' color='yellowgreen'/>
                  </IconButton>
                }
              </span>
            }
            style={{
              padding: '8px 0'
            }}
          />
          <Divider />
          <MessagesContainer >
            <Header
              user={selfUser}
              ticketId={urlParams.ticketId}
              status={status}
              category={category}
              reminder={reminder}
              handleChangeStatus={handleChangeStatus}
              handleChangeCategory={handleChangeCategory}
              handleDeleteReminder={handleDeleteReminder}
              handleSetReminder={handleSetReminder}
            />
            <MessageListBox
              messageList={messageList}
              loading={loading}
              uploadStatus={uploadStatus}
              audio={failedAudio}
              imageFile={imageFile}
              handleUploadVoice={() => handleUploadVoice(audioFile)}
              reloadMessages={getMessageList}
              category={category}
            />
          </MessagesContainer>
          <Divider />
          <WritingMessageBox>
            <AttachFile
             sendMessage={(params) => sendMessage(params)}
             startToUploading={(file) => startToUploadingFile(file)}
            />
            {!message.length && <IconButton aria-label="mic" onClick={handleMic}>
              {recordingStatus === 'inactive'
                ? <div
                    style={{display: 'flex', alignItems: 'center', gap: '4px'}}
                  >
                    <MicIcon style={{fontSize: '2rem'}} />
                    {selfUser?.type === 'user' && category.id !== 1 &&
                      <Typography>
                        {t('record_your_voice')}
                      </Typography>}
                  </div>
                : <SendIcon />
              }
            </IconButton>}
            {recordingStatus === 'recording' && <>
              <Button onClick={cancelRecording}>
                CANCEL
              </Button>
              <Timer>{time}</Timer>
            </>}
            {recordingStatus !== 'recording' && (selfUser?.type === 'admin' || category.id === 1) &&
              <>
                {!!message.length &&
                  <IconButton
                    onClick={() => sendMessage({type: 'text', message: message})}
                  >
                    <SendIcon style={{color: '#1d99d6'}} />
                  </IconButton>
                }
                <TextField
                  label=''
                  defaultValue=""
                  size="small"
                  variant="standard"
                  placeholder={t('write_your_message')}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyDown={(e) => handleKeyPress(e)}
                  value={message}
                  multiline
                />
              </>
            }
          </WritingMessageBox>
        </Card>
      </Wrapper>

      <ChangeStatusAlertModal
        open={statusAlert}
        handleClose={() => setStatusAlert(false)}
      />
      <MessageLimitModal
        open={openMessageLimit}
        category={category}
        status={status}
        handleClose={() => setOpenMessageLimit(false)}
      />
    </Container>
  );
}
